/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from "react";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from "@mui/material";
import { GridRowModel, GridRowSelectionModel } from "@mui/x-data-grid";

import DataGrid from "../simpleDataTable";
import { toast } from "react-toastify";

export interface IDialogProps {
    clienteOptions?: { label: string; value: number }[];
    clientsSelecteds?: any;
    onClose?: any;
    open: boolean;
}

const PersonSearchCheckbox: React.FC<IDialogProps> = ({
    open,
    onClose,
    clienteOptions = [],
    clientsSelecteds,
}: IDialogProps) => {
    const [linesSelecteds, setLinesSelecteds] = useState<GridRowSelectionModel>([]);
    const [persistedSelection, setPersistedSelection] = useState<GridRowSelectionModel>([]);
    const [searchValue, setSearchValue] = useState("");
    const [filteredOptions, setFilteredOptions] = useState(clienteOptions);

    const columns = useMemo(
        () => [
            {
                headerName: "ID",
                field: "value",
                type: "number",
                headerAlign: "left",
                identity: true,
                width: 70,
            },
            {
                headerName: "Informações do Cliente",
                field: "label",
                type: "string",
                minWidth: 500,
                flex: 1,
            },
        ],
        []
    );

    useEffect(() => {
        setFilteredOptions(
            clienteOptions.filter((option) => option.label.toLowerCase().includes(searchValue.toLowerCase()))
        );
    }, [searchValue, clienteOptions]);

    useEffect(() => {
        if (open) {
            setLinesSelecteds(persistedSelection);
        }
    }, [open]);

    return (
        <Dialog fullWidth={true} maxWidth="lg" open={open}>
            <DialogTitle>
                <form>
                    <Grid container spacing={2} display="flex" alignItems="center">
                        <Grid item md={12}>
                            <TextField
                                name="cliente"
                                label="Cliente"
                                fullWidth
                                onChange={(e) => {
                                    setSearchValue(e.target.value);
                                }}
                            />
                        </Grid>
                    </Grid>
                </form>
            </DialogTitle>
            <DialogContent>
                <Box sx={{ height: 450, mt: 3 }}>
                    <DataGrid
                        columns={columns}
                        rows={filteredOptions}
                        rowId={(row: GridRowModel) => row.value}
                        isLoading={clienteOptions.length === 0}
                        checkboxSelection
                        onRowSelectionModelChange={(newSelectionModel) => {
                            const visibleIds = filteredOptions.map(opt => opt.value);
                            const hiddenSelectedIds = persistedSelection.filter(id => !visibleIds.includes(Number(id)));
                            const updatedSelection = Array.from(new Set([...hiddenSelectedIds, ...newSelectionModel]));
                            
                            setLinesSelecteds(updatedSelection);
                            setPersistedSelection(updatedSelection);
                        }}
                        rowSelectionModel={linesSelecteds}
                    />
                </Box>
            </DialogContent>
            <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                <Button
                    variant="contained"
                    color="warning"
                    onClick={() => {
                        onClose();
                    }}
                    style={{ width: "159px", height: "44px" }}
                >
                    Cancelar
                </Button>
                <Button
                    disabled={linesSelecteds.length === 0}
                    variant="contained"
                    style={{ width: "159px", height: "44px" }}
                    onClick={() => {
                        if (linesSelecteds.length > 1000) {
                            return toast.error("O número máximo de clientes selecionados é: 1000!", {
                                autoClose: 2000,
                            });
                        }
                        setPersistedSelection(linesSelecteds);
                        clientsSelecteds(clienteOptions.filter((value) => linesSelecteds.includes(value.value)));
                        onClose();
                    }}
                >
                    Selecionar
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default PersonSearchCheckbox;
